import sp from '../../modules/module--scrollpoints';
import _bundle from '../../core/core--bundles';

export default function() {
    const $elMenu = $('.menu-topics--dynamic');
    const spInstance = sp.add({
        scrollpoint: '.scrollpoint--topic',
        offset: 0,
        elementOffset: 'brand', // by ID for now
        direction: 'both',
        menu: true,
        menuTitle: '.topic__title',
        debug: false
    });

    if ($elMenu.length) {
        // Build menu dynamically
        // Bundle Note: Should run before the bundle of "Module: AnchorsScroll" as the later needs the elements to run on
        _bundle.add({
            name: 'Build Aside Menu from Scrollpoints Topics',
            event: ['on:BundleReady', 'on:PageUpdate'],
            fn() {
                const $menuTopicsList = $('.menu-topics__list');
                function makeMenu() {
                    return $('<ul>', { class: 'menu-topics__list' }).append(
                        spInstance.get().map(({ name, id, isActive }) =>
                            $('<li>')
                                .addClass('menu-topics__item')
                                .append(
                                    $('<a>')
                                        .text(name)
                                        .attr('href', `#${id}`)
                                        .addClass('menu-topics__link slow-scroll')
                                )
                        )
                    );
                }
                $menuTopicsList.length ? $menuTopicsList.replaceWith(makeMenu()) : $elMenu.append(makeMenu());
            }
        });

        // Toggle Active Class
        _bundle.add({
            name: '',
            event: ['on:BundleReady', 'on:PageUpdate', 'on:Scroll'],
            fn() {
                spInstance.get().forEach(function(spw, i) {
                    if (spw.id)
                        $('.menu-topics__list')
                            .find(`a[href*=${spw.id}]`)
                            .parent()
                            .removeClass('active')
                            .addClass(spw.isActive && 'active');
                });
            }
        });
    }
}
